// askSmart-ui/src/pages/TOSP/components/TenantInfoStep.tsx
import React, { useState } from "react";

export interface TenantInfoValues {
  retailerType: string;
  wasteRemoval: string;
}

interface TenantInfoStepProps {
  retailerTypes: string[];
  wasteRemovalTypes: string[];
  onBack: () => void;
  /** The × — leave the wizard entirely, rather than stepping back. */
  onClose: () => void;
  onNext: (values: TenantInfoValues) => void;
}

// Step 3: Retailer Type and Waste Removal, from the lists under Configuration.
export default function TenantInfoStep({
  retailerTypes,
  wasteRemovalTypes,
  onBack,
  onClose,
  onNext,
}: TenantInfoStepProps) {
  const [retailerType, setRetailerType] = useState("");
  const [wasteRemoval, setWasteRemoval] = useState("");

  return (
    <>
      <div className="smrtdocs-modal-header tosp-wizard-header">
        <h2 style={{ margin: 0, fontSize: "1rem" }}>Tenant Info</h2>
        <button
          type="button"
          className="tosp-wizard-close"
          aria-label="Cancel"
          title="Cancel"
          onClick={onClose}
        >
          ×
        </button>
      </div>

      <div className="smrtdocs-modal-body">
        <div className="tosp-field">
          <label className="tosp-label" htmlFor="tosp-wizard-retailer">
            Retailer Type
          </label>
          <select
            id="tosp-wizard-retailer"
            className="manage-input"
            value={retailerType}
            onChange={(e) => setRetailerType(e.target.value)}
          >
            <option value="">— Select a retailer type —</option>
            {retailerTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        <div className="tosp-field">
          <label className="tosp-label" htmlFor="tosp-wizard-waste">
            Waste Removal
          </label>
          <select
            id="tosp-wizard-waste"
            className="manage-input"
            value={wasteRemoval}
            onChange={(e) => setWasteRemoval(e.target.value)}
          >
            <option value="">— Select a waste removal type —</option>
            {wasteRemovalTypes.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="tosp-wizard-actions">
        <button type="button" className="btn-cancel" onClick={onBack}>
          Back
        </button>
        <button
          type="button"
          className="tosp-wizard-next"
          disabled={!retailerType || !wasteRemoval}
          onClick={() => onNext({ retailerType, wasteRemoval })}
        >
          Next
        </button>
      </div>
    </>
  );
}
